import type { FormState } from '@guideguide/core/src/lib/types'
import type {
  SelectAction,
  WaitAction,
  SelectionRect,
  TypeAction,
  ClickActionTarget,
  ClickAction,
  DemoAction,
} from '@guideguide/shared/src/demo/types'

export const type = (field: keyof FormState, text: string): TypeAction => {
  return { type: 'type', field, text }
}

export const click = (target: ClickActionTarget): ClickAction => {
  return { type: 'click', target }
}

export const wait = (
  duration: number | 'move-between' | 'hold-to-process'
): WaitAction => {
  if (duration === 'move-between') duration = 500
  if (duration === 'hold-to-process') duration = 2000
  return { type: 'wait', ms: duration }
}

export const select = (
  rect: SelectionRect | null | ((rect: SelectionRect) => SelectionRect | null)
): SelectAction => {
  return { type: 'select', rect }
}

export const withTab = (
  tab: 'tabGrid' | 'tabCustom' | 'tabSaved',
  actions: DemoAction[]
): DemoAction[] => {
  return [click(tab), wait('move-between'), ...actions]
}
